import React from "react";

function Welcome(props) {
  return (
    <div className="panel center fadeIn">
      <div className="hero">

        <h1>
          Find the <span className="accent">PERFECT</span> Credit Card!
        </h1>

        <p>
          Answer a quick survey and get ranked recommendations with clear reasons.
        </p>

        {/* BIG CTA */}
        <button className="primaryBtn" onClick={props.onStart}>
          Get Started
        </button>

        {/* Checkmarks UNDER button */}
        <div className="welcomeMeta">
          <span>✓ Personalized</span>
          <span>✓ No sign-up</span>
          <span>✓ Under 1 minute</span>
        </div>

      </div>
    </div>
  );
}

export default Welcome;
